// TopShelf Live Rock Calculator: volume + aquascape density -> pounds of live rock.
document.addEventListener('DOMContentLoaded', function () {
  var volEl = document.getElementById('tsRockVolume');
  var unitEl = document.getElementById('tsRockUnit');
  var densityEl = document.getElementById('tsRockDensity');
  var result = document.getElementById('tsRockResult');

  if (!volEl || !unitEl || !densityEl || !result) {
    return;
  }

  function fmt(n) {
    return n.toLocaleString(undefined, { maximumFractionDigits: 1 });
  }

  function compute() {
    var vol = parseFloat(volEl.value);

    if (!vol || vol <= 0) {
      result.innerHTML = '<p class="ts-widget__hint">Enter your tank volume to estimate live rock.</p>';
      return;
    }

    var gallons = unitEl.value === 'liters' ? vol / 3.78541 : vol;
    var factor = parseFloat(densityEl.value); // lb per gallon
    var pounds = gallons * factor;
    var kg = pounds * 0.453592;

    result.innerHTML =
      '<ul class="ts-widget__results">' +
      '<li><span>Live rock</span><strong>' + fmt(pounds) + ' lb</strong></li>' +
      '<li><span>Live rock</span><strong>' + fmt(kg) + ' kg</strong></li>' +
      '</ul>' +
      '<p class="ts-widget__note">Modern open aquascapes use less rock than the old 1 to 2 lb per gallon rule. Mixing in dry or base rock with a smaller amount of live rock is an economical way to seed the same structure.</p>';
  }

  [volEl, densityEl].forEach(function (el) {
    el.addEventListener('input', compute);
    el.addEventListener('change', compute);
  });
  unitEl.addEventListener('change', compute);
  compute();
});
